var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.24 66.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b79e4918-2272-4c4b-9fa5-02866e7e077a",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f9a90a8c-280e-412a-b0f3-b7a4edf6ac92",
    "data-name": "ROAD MAPPING"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,10.63S20.47,6.91,27.26,15s10.3,10,17,7.78c0,0-.33,8.22-10.08,8.66S23.21,22.13,9.84,30.24Z",
    fill: "#f77f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.32,5.72l2.7.45L5.43,63.76A2.73,2.73,0,1,1,0,62.86L9.62,5.28Z",
    fill: "#0085cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62,5.28l2.7.44L2.28,66A2.73,2.73,0,0,1,0,62.86Z",
    fill: "#005d8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,5.72a5.73,5.73,0,1,1-11.45,0c0-.12,0-.24,0-.36A5.73,5.73,0,0,1,17,2.4,5.66,5.66,0,0,1,18,5.72Z",
    fill: "#d62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,5.72a5.73,5.73,0,1,1-11.45,0c0-.12,0-.24,0-.36A5.85,5.85,0,0,0,12.67,8C16.26,7.58,17.1,4.7,17,2.4A5.66,5.66,0,0,1,18,5.72Z",
    fill: "#ac2020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1,1.34C7.22,2.64,8,5.57,11,4.63S13.27-.07,10.1,1.34Z",
    fill: "#e36464"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.4109ed65.svg";
export { ForwardRef as ReactComponent };